module.exports = function MInteger(val) {
    var self = this;
    
    if (val !== undefined && typeof val !== "number") {
        throw new Error('Integer metadata must be given a numeric default value');
    }
    
    this.value = parseInt(val, 10) || 0;
    
    this.getDetails = function() {
        return {
            type : 'integerString',
            name : 'integerString',
            default : self.value
        };
    };
    
    this.parse = function(buffer) {
        return parseInt(buffer.toString(), 10);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/metadata/integer.js
// module id = 293
// module chunks = 1